export const SET_FILTER_VARIANTS = 'SET_FILTER_VARIANTS';
export const SET_FILTER_BY = 'SET_FILTER_BY';